import { globalData } from "../..";
import { DEFAULT_COLORS } from "../../colors";
import { ID_NAMES, pushToDataLayer, returnUrl } from "../../env";

const togglePlayerLink = ({ show }) => {

    const playerLink = document.getElementById(ID_NAMES.AFTER_PLAYER_CTA)

    if (!playerLink) {
        return
    }

    if (show) {
        playerLink.classList.add('active');
    } else {
        playerLink.classList.remove('active');
    }

}

//MODAL BOX OVERTOP VIDEO OR IFRAME
const playerLinkDiv = () => {

    const { ctaFontColor, ctaBackgroundColor } = DEFAULT_COLORS

    //AFTER VIDEO POP
    const playerLink = document.createElement("a");
    playerLink.id = ID_NAMES.AFTER_PLAYER_CTA;
    returnUrl(playerLink);
    playerLink.addEventListener("click", () => {
        pushToDataLayer({
            eventCategory: 'homepage',
            eventLabel: 'chat head video cta'
        })
    })

    //AFTER VIDEO TEXT ABOVE CTA
    const text = document.createElement("div");
    text.classList.add('chatheadAfterVideoText');
    text.textContent = 'WANT TO SEE MORE?'

    //AFTER VIDEO CTA
    const cta = document.createElement("div");
    cta.classList.add('chatheadAfterVideoCta');
    cta.textContent = 'JOIN FREE'
    cta.style.color = ctaFontColor;
    cta.style.backgroundColor = ctaBackgroundColor;

    playerLink.append(text)
    playerLink.append(cta)

    return playerLink
}

export { togglePlayerLink }
export default playerLinkDiv